<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="col-sm-12">
            <vs-breadcrumb
              align="left"
              :items="
                  [
                   {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Trainee/traineeDashboard'
                    },
                    {
                      title: 'Feedback',
                      url: '/#/dashboard/Trainee/feedback',
                      active: true
                    }
                  ]"
            ></vs-breadcrumb>
            <div class="questionScreen d-flex flex-column">
              <div class="d-flex p-2">
                <div class="training-code pr-2">
                  <h6 class="training-code-clr">T001</h6>
                </div>
                <div class="training-title">
                  <h6>{{trainings.title}}</h6>
                  <small>{{trainings.startdate}} - {{trainings.enddate}}</small>
                  <p>{{trainings.address}}</p>
                </div>
              </div>
              <div class="pl-3 mb-2">
                <h5>Feedback</h5>
              </div>
              <template v-if="submittedStatus == 0">
                <form @submit.prevent="traineefeedbacksubmit">
                  <div class="question pl-3" v-if="feedbackQuestions.length >0">
                    <input type="hidden" v-model="training_id" />
                    <h6
                      v-if="feedbackQuestions[currentQ] != undefined && feedbackQuestions[currentQ].qtitle != undefined"
                    >Question {{currentQ+1}} OF {{feedbackQuestions.length}}</h6>
                    <p>
                      <b>{{currentQ+1}}){{feedbackQuestions[currentQ].qtitle}} {{feedbackQuestions[currentQ].question}}</b>
                    </p>
                  </div>
                  <div v-else>
                    <h6 class="text-left text-dark ml-3">No Feedback Found</h6>
                  </div>
                  <div class="options ml-3">
                    <p>
                      <i>Click on the right option below</i>
                    </p>
                    <ul>
                      <li
                        class=""
                        v-for="(options,index) in feedbackQuestionOptions"
                        :key="index"
                      >
                        <template
                          v-if="options.oquestionBank_id == feedbackQuestions[currentQ].qid"
                        >
                          <vs-radio
                            v-model="selectedOptions[currentQ].answer"
                            :vs-value="options.oid"
                          >{{options.otitle}}</vs-radio>
                        </template>
                      </li>
                    </ul>
                    <template v-if="selectedOptions !=''">
                      <b-button
                        type="submit"
                        class="save-btn float-left"
                        variant="primary"
                        v-if="currentQ+1 == feedbackQuestions.length & selectedOptions[feedbackQuestions.length - 1].answer !='' "
                      >Submit</b-button>

                      <div v-else>
                        <b-button
                          v-if="selectedOptions[currentQ].answer !=''"
                          class="save-btn float-left"
                          variant="primary"
                          @click="next()"
                        >Next</b-button>
                      </div>
                    </template>
                  </div>
                </form>
              </template>
              <template v-else>
                <div>
                  <h6>You have submitted Feedback</h6>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  data: () => ({
    isSidebar: false,

    Trainingtitle: [],
    trainings: "",
    TrainingDates: [],
    feedbackQuestions: [],
    submittedStatus: "",
    feedbackQuestionOptions: [],
    selectedOptions: [],
    training_id: "",
    indexActive: 0,
    checkBox1: false,
    checkBox2: false,
    checkBox3: false,
    checkBox4: false,
    currentQ: 0,
    trainingCode: ""
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.trainingCode = this.$route.query.training;
    this.openLoading();
    axios
      .get(
        process.env.VUE_APP_BASE_PATH +
          "/get/trainee/trainingdetails/" +
          this.trainingCode
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.trainings = response.data;
        this.training_id = this.trainings.id;
        this.checkFeedback(this.training_id);
      });
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  methods: {
    allQuestions: function allQuestions(trngId) {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/trainee/training/feedback/get/" +
            JSON.parse(localStorage.getItem("currentUser")).id +
            "/" +
            trngId
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.feedbackQuestions = response.data["questionArray"];
          for (var i = 0; i < this.feedbackQuestions.length; i++) {
            this.selectedOptions.push({
              lengthh: i,
              answer: "",
              assesmentID: this.feedbackQuestions[i].assesmentID
            });
          }
          this.feedbackQuestionOptions = response.data["optionArray"][0];
        });
    },
    checkFeedback: function checkFeedback(trId) {
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/check/trainee/feedback/" +
            JSON.parse(localStorage.getItem("currentUser")).id +
            "/" +
            trId
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data && response.data.count == 1) {
            this.submittedStatus = response.data.count;
          } else {
            this.submittedStatus = response.data.count;
            this.allQuestions(trId);
          }
        });
    },
    traineefeedbacksubmit(e) {
      e.preventDefault();
      this.inValid = [];
      let self = this;
      this.selectedOptions.forEach(element => {
        if (element.answer == "") {
          this.inValid.push("Please select an option.");
        }
      });
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        this.openLoading();
        axios
          .post(
            process.env.VUE_APP_BASE_PATH + "/trainee/feedbacksubmit/save",
            {
              feedback: this.selectedOptions,
              trainee_id:
                JSON.parse(localStorage.getItem("currentUser")).id + "",
              training_id: this.training_id
            }
          )
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Feedback Submitted Successfully!");
              this.submittedStatus = 1;
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    },
    formSubmitted() {
      alert("Form submitted!");
    },
    next: function() {
      if (this.currentQ + 1 < this.feedbackQuestions.length) {
        this.currentQ++;
      }
    }
  }
};
</script>
<style>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
li {
  list-style-type: none !important;
}
.feedback_submitted {
  text-align: center;
}
.f-500 {
  font-weight: 500;
}
.questionScreen {
  border: 1px solid #fff0a2;
  background-color: #fffae5;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
}
.training-code-clr {
  color: #eadb89;
}
.question h6 {
  text-decoration: underline;
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}
.con-vs-radio {
  justify-content: left !important;
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #fff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.save-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 0px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #f9f9f9;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}

/****  floating-Lable style end ****/

/* Floating label css ends */

/* Uploading file css */
/* .con-img-upload .img-upload{
  height:25px !important;
}
.con-input-upload{
  height:25px !important;
}
h4.text-archive{
  font-size: 13px !important
}
.con-img-upload .img-upload .btn-x-file i{
  font-size:10px !important;
}
.con-img-upload .img-upload .btn-upload-file:not(.on-progress):hover i{

    font-size: 12px !important;
    background: rgba(var(--vs-success),1);
    top: 15% !important;
    padding: 10px;
}

.vs-upload--button-upload:hover {
    padding-bottom: 0px !important;
    padding-top: 0px !important;
    background: rgba(var(--vs-primary),1);
    color: #fff;
} */
.vs-popup--background {
  opacity: 0.3 !important;
}
.con-img-upload .img-upload {
  width: 150px !important;
}
</style>


